import { render } from "./BarItem.vue?vue&type=template&id=445286e6&scoped=true"
import script from "./BarItem.vue?vue&type=script&lang=js"
export * from "./BarItem.vue?vue&type=script&lang=js"

import "./BarItem.vue?vue&type=style&index=0&id=445286e6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-445286e6"]])

export default __exports__